<template>
  <div
    class="views-page is-flex is-flex-direction-column p-3 pb-5"
    style="min-height: 50vh; background: #FFF;"
  >
    <div
      class="info-line"
      :class="branchData.main_color"
    />
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    />
    <div class="is-flex is-flex-direction-column" style="gap: 1rem">
      <div class="is-flex is-align-items-center mb-3">
        <b-button
          outlined
          size="is-small"
          @click="goBack"
        >
          Назад
        </b-button>
        <h2 class="is-size-5 has-text-weight-semibold ml-3">
          {{ branchData.name || 'Филиал' }} | Рассылка
        </h2>
      </div>

      <div v-if="!isLoading && emails.length > 0">
        <h3 class="is-size-6 has-text-weight-semibold mb-3">
          Список получателей ({{ emails.length }})
        </h3>
        <div class="tags">
          <b-tag
            v-for="email in emails"
            :key="email"
            type="is-info"
            closable
            @close="onEmailDelete(email)"
          >
            {{ email }}
          </b-tag>
        </div>
      </div>

      <p v-if="!isLoading && emails.length === 0" class="has-text-centered has-text-grey">
        Нет добавленных email адресов
      </p>
      <div>
        <h3 class="is-size-6 has-text-weight-semibold mb-3">Добавить получателей</h3>
        <b-field
          label="Список email адресов (через запятую)"
          :type="emailsError ? 'is-danger' : ''"
          :message="emailsError"
        >
          <b-input
            v-model="emailsInput"
            type="textarea"
            placeholder="example1@mail.com, example2@gmail.com, example3@yandex.ru"
            rows="4"
            maxlength="2000"
            :loading="isSubmitting"
          />
        </b-field>

        <div class="is-flex is-justify-content-flex-end" style="gap: 0.5rem">
          <b-button
            @click="clearEmails"
            :disabled="!emailsInput.trim()"
          >
            Очистить
          </b-button>
          <b-button
            type="is-primary"
            @click="submitEmails"
            :loading="isSubmitting"
            :disabled="!emailsInput.trim()"
          >
            Добавить почты
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
  props: ["branch_id"],
  data() {
    return {
      emails: [],
      isLoading: true,
      emailsInput: '',
      emailsError: '',
      isSubmitting: false,
      validEmails: [],
      branchData: {}
    }
  },
  computed: {
    ...mapGetters(["getUser"]),
    isManager() {
      return this.getUser?.role_id === 3
    }
  },
  watch: {
    emailsInput: {
      handler(newVal) {
        this.validateEmails(newVal)
      },
      immediate: true
    }
  },
  created() {
    // this.getBranchData()
    this.getEmails()
  },
  methods: {
    ...mapMutations(["ChangeNavName"]),

    // async getBranchData() {
    //   try {
    //     const { data } = await this.$axios.get(`manager/branches/${this.branch_id}`)
    //     this.branchData = data || {}
    //   } catch (e) {
    //     console.error(e)
    //   }
    // },

    async getEmails() {
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`manager/branches/${this.branch_id}/ai-emails`)
        this.branchData = data?.branch || {}
        this.emails = data?.emails || []
      } catch (e) {
        this.isLoading = false
        throw new Error(e)
      }
      this.isLoading = false
    },

    async deleteEmail(email) {
      try {
        await this.$axios.delete(`manager/branches/${this.branch_id}/ai-emails`, {
          data: { email }
        })
        await this.getEmails()
        this.$buefy.toast.open({
          message: 'Email адрес успешно удален',
          type: 'is-success'
        })
      } catch (e) {
        console.error(e)
        this.$buefy.toast.open({
          message: 'Ошибка при удалении email адреса',
          type: 'is-danger'
        })
        throw e
      }
    },

    onEmailDelete(email) {
      this.$buefy.dialog.confirm({
        title: 'Подтвердите удаление',
        message: `Вы уверены, что хотите удалить адрес <strong>${email}</strong>? Это действие необратимо.`,
        confirmText: 'Да, удалить',
        cancelText: 'Отмена',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteEmail(email)
        }
      })
    },

    validateEmails(input) {
      this.emailsError = ''
      this.validEmails = []

      if ( !input || !input.trim()) {
        return
      }

      try {
        const emailList = input
          .split(',')
          .map(email => email.trim())
          .filter(email => email.length > 0)

        if (emailList.length === 0) {
          this.emailsError = 'Введите хотя бы один email адрес'
          return
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        const validEmails = []
        const invalidEmails = []

        emailList.forEach(email => {
          if (emailRegex.test(email)) {
            validEmails.push(email)
          } else {
            invalidEmails.push(email)
          }
        })

        if (invalidEmails.length > 0) {
          this.emailsError = `Некорректные email адреса: ${invalidEmails.slice(0, 3).join(', ')}${invalidEmails.length > 3 ? ` и еще ${invalidEmails.length - 3}` : ''}`
          return
        }

        const uniqueEmails = [...new Set(validEmails)]
        if (uniqueEmails.length !== validEmails.length) {
          this.emailsError = 'Найдены дублирующиеся email адреса'
          return
        }

        const existingEmails = uniqueEmails.filter(email => this.emails.includes(email))
        if (existingEmails.length > 0) {
          this.emailsError = `Email адреса уже добавлены: ${existingEmails.slice(0, 3).join(', ')}${existingEmails.length > 3 ? ` и еще ${existingEmails.length - 3}` : ''}`
          return
        }

        this.validEmails = uniqueEmails

      } catch (e) {
        this.emailsError = 'Ошибка при обработке списка email адресов'
        console.error('Email parsing error:', e)
      }
    },

    async submitEmails() {
      if (this.validEmails.length === 0) {
        this.$buefy.toast.open({
          message: 'Нет валидных email адресов для отправки',
          type: 'is-warning'
        })
        return
      }

      this.isSubmitting = true

      try {
        const payload = {
          emails: this.validEmails
        }

        await this.$axios.post(`manager/branches/${this.branch_id}/ai-emails`, payload)
        this.$buefy.toast.open({
          message: `Успешно добавлено ${this.validEmails.length} email адресов`,
          type: 'is-success'
        })

        this.clearEmails()
        await this.getEmails()

      } catch (e) {
        console.error('Submit emails error:', e)
        this.$buefy.toast.open({
          message: e.response?.data?.message || 'Ошибка при добавлении email адресов',
          type: 'is-danger'
        })
      } finally {
        this.isSubmitting = false
      }
    },

    clearEmails() {
      this.emailsInput = ''
      this.emailsError = ''
      this.validEmails = []
    },

    goBack() {
      this.$router.push({ path: '/' })
    }
  },
}
</script>

